/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit, Input } from '@angular/core';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {
  IcecontrolSettings,
  IcemattableSettings,
  IcepanelsectionSettings,
  IcepanelSettings,
  IcepanelcontainerRowSettings,
  IcepanelcontainerSettings,
  iceColumnDefinition
} from '../../../../icemedx-lib/src/components/models/icesettings';
import { IIceEntity } from '../../../../icemedx-lib/src/models/core/IceEntity';
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';
import { IBaseView } from '../../../../icemedx-lib/src/components/baseview.component';
import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';
import { user } from 'projects/icemedx-lib/src/models/common/user';
import { externaldata } from 'projects/icemedx-lib/src/models/ehr/externaldata';
import { message } from '../../../../icemedx-lib/src/models/messages/message';
import { IcepanelService } from '../../../../icemedx-lib/src/components/icepanel/icepanel.service';
import { MatTableDataSource } from '@angular/material';
import { MessageService } from '../../../../icemedx-lib/src/services/message/message.service';
import { XmlparseService } from '../../../../icemedx-lib/src/services/xml/xmlparse.service';
import { LoginService } from '../../../../icemedx-lib/src/login/login.service';
import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { AppService } from '../app.service';
import { userTypes } from '../../../../icemedx-lib/src/login/login.config';
import { MedicalcodesService } from 'projects/icemedx-lib/src/services/medicalcodes/medicalcodes.service';
import { DomainService } from 'projects/icemedx-lib/src/services/domain/domain.service';
import { patientindex } from '../../../../icemedx-lib/src/models/common/patientindex';

const SendMessage: string = "SendMessage";
const SaveDraft: string = "SaveDraft";
const CancelSending: string = "Cancel";

@Component({
  selector: 'newmessage',
  templateUrl: './newmessage.component.html',
  styleUrls: ['./newmessage.component.scss'],
  providers: [IcepanelService, MessageService, XmlparseService, IceNavService, AppService]
})
export class NewmessageComponent implements IBaseView, OnInit {
  // Data members
  public _messageKey: string = "";
  public msg: message = new message();
  private attachments: any[] = [];
  private documentTypes: any[];
  private message: string = "";
  private receipientName: string = "";
  private subject: string = "";
  private privateNetworkAccess: boolean = false;
  private members: user[] = [];
  private panelHeading: string = "";
  private panelTag: string = "";
  private panelKey: string = "";
  private attachmentMap: any = {};
  private toUser: any = null;

  // Control Memebers
  public messageSettings: IcepanelcontainerSettings = null;
  public tables: IcemattableSettings[];
  registerMemberSettings: IcecontrolSettings = new IcecontrolSettings("RegisterMemberButton", { text: "Add New Patient Portal Member", class: [], glyphClass: "fa-user" }, null, null);
  private attachmentsDataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  private messageBodyCtrl: IcecontrolSettings = new IcecontrolSettings("icetextarea", { width: "100%", hasFullWidthContainer: true }, null, null, "MessageBody", "Enter Message");
  private recipientsCtrl: IcecontrolSettings = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "500px", hasFullWidthContainer: true }, null, null,
    "Recipients",
    "Enter recipient's first or last name").setMultipleSelection(true);
  private dropzoneAttachmentCtrl: IcecontrolSettings = new IcecontrolSettings(
    "icedragdrop",
    {
      acceptedFiles: '.jpg, .png, .txt, .pdf, .xls, .doc, .docx'
    }, null, null,
    "",
    "Drop files here to upload"
  );
  private subjectCtrl: IcecontrolSettings = new IcecontrolSettings("iceinput", { width: "100%", hasFullWidthContainer: true }, null, null, "Subject", "Subject");

  private attachmentTypeCtrl: IcecontrolSettings = new IcecontrolSettings("icelabel", { linkMode: "labelselect", menuItems: [], width: "150px" }, null, null, "sub_type", "Type")
    .setControlName("sub_type")
    .createFormControl(0, [Validators.required]);

  getRouter(): Router { return this.router; }
  getAppService(): AppService { return this.appSvc; }
  getMessageService(): MessageService { return this.messageService; }
  getDomainService(): DomainService { return this.domainSvc; }
  getNavService(): IceNavService { return this.navSvc; }
  getLoginService(): LoginService { return this.loginSvc; }

  setPanelHeading(txt: string): void { this.panelHeading = txt; }
  setPanelTag(tag: string): void { this.panelTag = tag; }
  setPanelKeyg(key: string) { this.panelKey = key; }

  getPanelHeading(): string { return this.panelHeading; }

  constructor(private router: Router,
    private appSvc: AppService,
    private medicalCodesService: MedicalcodesService,
    private loginSvc: LoginService,
    private messageService: MessageService,
    private domainSvc: DomainService,
    private navSvc: IceNavService,
    private activatedRoute: ActivatedRoute) {

    this.appSvc.defaultMenus();

    this.setPanelHeading("New Message");
    this.setPanelTag("New Message");

    let ptAct = appSvc.getCurrentPatient();
    let currAct = appSvc.getCurrentAccount();
    let currActType = appSvc.getCurrentAccountType();

    this.domainSvc.dataSubject$.subscribe(data => {
      this.toUser = Iceutility.isdefined(data) ? data.login_user_name : null;
    });

    this.medicalCodesService
      .getCodes("SUBTYPE_ITEM", "", "", "")
      .subscribe(data => {
        if (data == null || data.length == 0) return;
        this.documentTypes = data;;
        this.attachmentTypeCtrl.setOptions(this.documentTypes.map(s => { return { name: s.title, value: s.sub_type } }));
      }, error => {
        console.log(JSON.stringify(this.messageService.getLastErrors()));
      });

    this.activatedRoute.params.subscribe(next => {
      if (next != null && next.key != null && next.key.length > 0 && next.key != "0") {
        this.messageService.getMessage(next.key).subscribe(
          data => {
            if (data && data.length > 0 && data[0] != null) {
              this._messageKey = next.key;
              let msgObj = data[0];

              if (msgObj.to.length > 0) {
                let selectedRecips = msgObj.to.split(',');
                let toRecipientNames = [];

                if (selectedRecips != null && selectedRecips.length > 0) {
                  this.domainSvc.mapMembers(msgObj.to).subscribe(
                    data => {
                      for (let i = 0; i < selectedRecips.length; i++) {
                        let toRecipient = selectedRecips[i].trim(),
                          toUser = DomainService.mappedMembers[toRecipient.toLowerCase()];

                        toRecipientNames.push({ "name": toUser ? toUser.first_name + " " + toUser.last_name : toRecipient, "value": toRecipient });
                      }
                      msgObj["_recipients"] = JSON.stringify(toRecipientNames);
                      this.messageSettings = this.viewSetup(msgObj);
                    },
                    error => {
                      console.log(JSON.stringify(this.domainSvc.getLastErrors()));
                      this.messageSettings = this.viewSetup(msgObj);
                    });
                } else {
                  this.messageSettings = this.viewSetup(msgObj);
                }
              } else {
                this.messageSettings = this.viewSetup(msgObj);
              }
            }
          },
          error => {
            console.log(JSON.stringify(this.messageService.getLastErrors()));
          });
      }
      else if (next != null && next.member != null && next.member.length > 0) {
        // lookup info for member
      }
      else {
        this._messageKey = Iceutility.guid(true);
        let msg: message = new message();
        msg.message_key = this._messageKey;
        msg.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;

        if (Iceutility.isdefined(this.toUser)) {
          this.domainSvc.mapMembers(this.toUser).subscribe(
            data => {
              let toRecipient = DomainService.mappedMembers[this.toUser.trim().toLowerCase()],
                toRecipientNames = [{ "name": toRecipient ? toRecipient.first_name + " " + toRecipient.last_name : this.toUser, "value": this.toUser }];
              msg["_recipients"] = JSON.stringify(toRecipientNames);
              this.messageSettings = this.viewSetup(msg);
            },
            error => {
              console.log(JSON.stringify(this.domainSvc.getLastErrors()));
              this.messageSettings = this.viewSetup(msg);
            });
        } else {
          this.messageSettings = this.viewSetup(msg);
        }
      }
    });

    if (!Iceutility.isStringUndefinedNullOrEmpty(ptAct) && !Iceutility.isStringUndefinedNullOrEmpty(currAct) && ptAct !== currAct) {
      this.appSvc.onPatientReady(ptAct).subscribe(
        pt => {
          this.getMemberList(pt.trans_account, IceTypes.ACCOUNT_TYPE.actPatient);
          this.getMemberList(currAct, currActType);
        });
    } else if (!Iceutility.isStringUndefinedNullOrEmpty(currAct)) {
      this.getMemberList(currAct, currActType);
    }

    // get all public network members
    this.getMemberList(null, IceTypes.ACCOUNT_TYPE.actNone);

    if (Iceutility.isStringUndefinedNullOrEmpty(ptAct) && Iceutility.isStringUndefinedNullOrEmpty(currAct)) {
      // this is when no domain is open and there are patient's in the members network
      this.domainSvc.getPatients().subscribe(
        data => {
          let prvs = data;
          if (prvs) {
            for (let i = 0; i < prvs.length; i++) {
              let p: patientindex = prvs[i];
              if (p != null) {
                this.getMemberList(p.trans_account, IceTypes.ACCOUNT_TYPE.actPatient);
              }
            }
          }
        },
        error => {
          console.log(JSON.stringify(this.domainSvc.getLastErrors()));
        });
    }
  }

  ngOnInit() {
    this.appSvc.refreshMenus();
  }

  ngOnDestroy() {
  }

  onAttachmentRemoveClick(event): void {
    if (Iceutility.isdefined(event.upload.uuid)) {
      let index = Iceutility.getObjectIndexFromArray(this.attachments, "uuid", event.upload.uuid);
      this.attachments.splice(index, 1);
      this.attachmentsDataSource.data = this.attachments;

      if (this.attachments.length == 0) this.dropzoneAttachmentCtrl.properties.height = '200px';
      let filUploaded: File = event;
      if (filUploaded != null) {
        index = Iceutility.getObjectIndexFromArray(this.msg.ATTACHMENTS, "external_data_key", this.attachmentMap[filUploaded["upload"].uuid]);
        if (index >= 0)
          this.msg.ATTACHMENTS.splice(index, 1);

        this.messageService.removeMessageAttachment(this.appSvc.getCurrentAccount(),
          this.appSvc.getCurrentAccountType(),
          this.msg.message_key,
          IceTypes.SourceType.srcMiscellaneousForms,
          this.attachmentMap[filUploaded["upload"].uuid]).subscribe(data => {
            console.log("File successfully removed");
          }, error => {
            console.log(error);
          });
      }
    }
  }


  onAttachmentUploadSuccessClick(event): void {
    if (Iceutility.isdefined(event) && event.length > 0) {
      let filUploaded: File = event[0];

      if (filUploaded && event.length > 1) {
        let extdataAry: externaldata[] = <externaldata[]>this.getMessageService().geticexdocumentobjects(event[1], ["EXTERNAL_DATA"])
        if (extdataAry == null || extdataAry.length == 0) {
          this.messageService.logMessage(IceTypes.LOGTYPE.ltError, "An error occurred while uploading the file");
          return;
        };

        let obj = {
          "original_path": event[0].name,
          "title": event[0].name,
          "sub_type": "",
          "external_reference_date": Iceutility.getDateTextEx(Iceutility.GetLocalDate()),
          "external_reference_end_date": Iceutility.getDateTextEx(Iceutility.GetLocalDate()),
          "uuid": filUploaded["upload"].uuid,
          "external_data_key": extdataAry[0].external_data_key
        };
        this.attachments.push(obj);
        this.attachmentsDataSource.data = this.attachments;
        this.attachmentMap[filUploaded["upload"].uuid] = extdataAry[0].external_data_key;
        this.msg.ATTACHMENTS.push(extdataAry[0]);
      }
    }
  }

  ///////////////////////
  // public functions //
  ///////////////////////

  public onHeaderActionClick(event) {
    if (event.headerCtrl && event.headerCtrl.id == CancelSending) {
      this.router.navigate([this.navSvc.buildRoute("messages", false)]);
      return;
    }

    if (event.headerCtrl instanceof IcepanelSettings) {
      let newMessagePanel: IcepanelSettings = event.headerCtrl;
      let newMessageForm: FormGroup = newMessagePanel.getForm();
      if (newMessageForm == null || false == newMessageForm.valid) {
        console.log("Invalid form");
        return;
      }
    }

    let userInfo = this.loginSvc.GetSessionUserInfo();

    if (Iceutility.isdefined(userInfo)) {
      this.msg.from = userInfo.Username;

      let ctrSubject: FormControl = this.subjectCtrl.getFormControl();
      if (ctrSubject != null) {
        this.msg.subject = ctrSubject.value;
      }
      let ctrMessageBody: FormControl = this.messageBodyCtrl.getFormControl();
      if (ctrMessageBody != null) {
        this.msg.message_body = ctrMessageBody.value;
      }
      let recipient: FormControl = this.recipientsCtrl.getFormControl();
      if (Iceutility.isdefined(recipient) && Iceutility.isdefined(recipient.value) && recipient.value.length > 0) {

        try {
          let selectedRecips = JSON.parse(recipient.value);
          if (selectedRecips == null || selectedRecips.length == 0) {
            this.msg.to = recipient.value;
          }
          else {
            this.msg.to = "";
            for (let i = 0; i < selectedRecips.length; i++) {
              if (this.msg.to.length > 0) this.msg.to += ",";
              this.msg.to += selectedRecips[i].value;
            }
          }
        }
        catch (e) {
          this.messageService.logMessage(IceTypes.LOGTYPE.ltError, e);
          return;
        }
      }

      this.msg.message_date = Iceutility.ConvertToUTC(Iceutility.GetLocalDate(), true);
      this.msg.trans_account = this.appSvc.getCurrentAccount();
      this.msg.account_type = this.appSvc.getCurrentAccountType();
      this.msg.message_status = IceTypes.trans_status.isReadyToSend;
      this.msg.trans_type = IceTypes.TRANSTYPE.itNone;

      if (event.headerCtrl.id == SaveDraft) {
        if (this.msg.offline_record_status == IceTypes.offlineRecStatus.offlineInsert) {
          this.messageService.addMessage(this.msg, this.navSvc).subscribe(data => {
            this.router.navigate([this.navSvc.buildRoute("messages", false)]);
          }, error => {
            console.log(error);
          });
        }
        else {
          this.messageService.updateMessage(this.msg, this.navSvc).subscribe(data => {
            this.router.navigate([this.navSvc.buildRoute("messages", false)]);
          }, error => {
            console.log(error);
          });
        }
      }
      else {
        this.messageService.sendMessage(this.msg, this.navSvc).subscribe(data => {
          this.router.navigate([this.navSvc.buildRoute("messages", false)]);
        }, error => {
          console.log(error);
        });
      }
    } else {
      console.error("Invalid user");
    }
  }

  onRegisterMember(event) {
    let act: string = this.appSvc.getCurrentAccount();
    let acttype: IceTypes.ACCOUNT_TYPE = this.appSvc.getCurrentAccountType();
    let ptact: string = this.appSvc.getCurrentPatient();

    this.loginSvc.doRegisterMember(acttype == IceTypes.ACCOUNT_TYPE.actPatient ? act : ptact,
      IceTypes.ACCOUNT_TYPE.actPatient,
      acttype != IceTypes.ACCOUNT_TYPE.actPatient ? act : "",
      acttype != IceTypes.ACCOUNT_TYPE.actPatient ? acttype : IceTypes.ACCOUNT_TYPE.actNone,
      false);
  }

  viewSetup(dat: IIceEntity): IcepanelcontainerSettings {
    if (dat == null) return null;

    let ret: IcepanelcontainerSettings = null;
    try {
      this.msg = <message>dat;
      this.setMemberAutomcompleteList(this.msg);

      this.appSvc.addBreadcrumb(this.getPanelHeading(), {}, true, "");
      this.appSvc.addBreadcrumb(this.msg.subject, {}, true, "");
      this.setPanelKeyg(Iceutility.guid(false));

      let controls: IcecontrolSettings[] = [];
      let headerControls: IcecontrolSettings[] = [];
      let userInfo = this.loginSvc.GetSessionUserInfo();
      this.recipientsCtrl.setControlName("Recipients")
        .createFormControl(this.msg.to, []);
      this.subjectCtrl.setControlName("Subject")
        .createFormControl(this.msg.subject, [Validators.required]);
      this.messageBodyCtrl.setControlName("Message")
        .createFormControl(this.msg.message_body, [Validators.required]);

      let recipient: FormControl = this.recipientsCtrl.getFormControl();
      if (Iceutility.isdefined(this.msg["_recipients"])) {
        recipient.setValue(this.msg["_recipients"]);
      } else {
        recipient.setValue("");
      }

      ///////////////////////
      // New message panel //
      ///////////////////////

      this.dropzoneAttachmentCtrl.properties.url = this.getMessageService().getMessageFileUploadUri(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), this.msg.message_key, "", IceTypes.SourceType.srcMiscellaneousForms);
      this.dropzoneAttachmentCtrl.properties.headers = { 'Authorization': 'Bearer ' + this.loginSvc.GetAccessToken(userInfo) };

      controls = [
        new IcecontrolSettings(
          "icelabel",
          {
            value: this.msg.offline_record_status == IceTypes.offlineRecStatus.offlineInsert ? Iceutility.getDateTextEx(Iceutility.GetLocalDate()) : "Message Date: " + Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(this.msg.message_date)), width: "300px", hasFullWidthContainer: true
          }, null, null),
        new IcecontrolSettings(
          "icelabel",
          { value: this.msg.offline_record_status == IceTypes.offlineRecStatus.offlineInsert ? "From: " + userInfo.Name : "From: " + this.msg.from, width: "300px", hasFullWidthContainer: true },
          null,
          null
        ),
        this.recipientsCtrl,
        this.subjectCtrl,
        this.messageBodyCtrl,
        this.dropzoneAttachmentCtrl
      ];
      headerControls = [
		  new IcecontrolSettings("icesubmitbutton", { class: "fas fa-paper-plane", width: "50px", tooltip: "Send" }, null, null, SendMessage),
		  new IcecontrolSettings("icebutton", { class: "fas fa-save", width: "20px", tooltip: "Save Draft" }, null, null, SaveDraft),
		  new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px", tooltip: "Cancel" }, null, null, CancelSending)
      ];

      this.tables = [
        new IcemattableSettings(
          "NewMessageTable",
          [
            new iceColumnDefinition("title", "Title", false, false),
            new iceColumnDefinition("original_path", "File", false, true),
            new iceColumnDefinition("sub_type", "Type", false, true,
              this.attachmentTypeCtrl),
            new iceColumnDefinition("external_reference_date", "Date", false, true,
              new IcecontrolSettings("icedatepicker", { placeholder: "Select a date" }, null, null)),
            new iceColumnDefinition("external_reference_end_date", "End Date", false, true,
              new IcecontrolSettings("icedatepicker", { placeholder: "Select a date" }, null, null)),
            new iceColumnDefinition("uuid", "", false, true),
            new iceColumnDefinition("external_data_key", "", true, true)
          ],
          this.attachmentsDataSource,
          [],
          false,
          null,
          false
        )
      ];
      let sections: IcepanelsectionSettings[] = [
        new IcepanelsectionSettings(
          "AttachmentSection",
          {
            class: [""],
            styles: {
              width: "100%"
            }
          },
          null,
          controls,
          this.tables)
      ];
      let panels: IcepanelSettings[] = [
        new IcepanelSettings("New Message", Iceutility.guid(false), this.panelHeading, "", sections, headerControls)
          .enableForm()
      ];
      let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
      ret = new IcepanelcontainerSettings(this.panelTag, panelrows);

      for (let iatch = 0; iatch < this.msg.ATTACHMENTS.length; iatch++) {
        let obj = {
          "original_path": this.msg.ATTACHMENTS[iatch].original_path,
          "title": this.msg.ATTACHMENTS[iatch].title,
          "sub_type": "",
          "external_reference_date": Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(this.msg.ATTACHMENTS[iatch].external_reference_date)),
          "external_reference_end_date": Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(this.msg.ATTACHMENTS[iatch].external_reference_end_date)),
          "uuid": "",
          "external_data_key": this.msg.ATTACHMENTS[iatch].external_data_key
        };
        this.attachments.push(obj);
      }
      this.attachmentsDataSource.data = this.attachments;

    }
    catch (e) {
      console.log(e);
    }
    return ret;
  }

  ///////////////////////
  // private functions //
  ///////////////////////

  private getMemberList(account: string, accountType: IceTypes.ACCOUNT_TYPE) {
    if (IceTypes.ACCOUNT_TYPE.actNone == accountType) {
      this.domainSvc.getNetworkOfMembers().subscribe(
        data => {
          if (data && data.length > 0) {
            this.members = this.members.concat(data);

            let opts = data.map(m => { return { value: m.login_user_name, name: m.getdisplayname() + " (from your public network)" } });
            this.recipientsCtrl.setOptions(this.recipientsCtrl.getOptions().concat(opts));
          }
        },
        error => {
          console.log(JSON.stringify(this.domainSvc.getLastErrors()));
        });
      return;
    }

    this.domainSvc.getMembersList(account, accountType).subscribe(
      data => {
        if (data && data.length > 0) {
          this.members = this.members.concat(data);

          let ptName = "";

          let pt = this.appSvc.getPatient();
          if (pt != null && IceTypes.ACCOUNT_TYPE.actPatient == accountType) {
            ptName = " (member from '" + pt.getName() + "' patient network)";
          }

          let opts = data.map(m => { return { value: m.login_user_name, name: m.getdisplayname() + ptName } });
          this.recipientsCtrl.setOptions(this.recipientsCtrl.getOptions().concat(opts));
        }
        else {
          let userInfo = this.loginSvc.GetSessionUserInfo();
          if (this.appSvc.getCurrentAccountType() == IceTypes.ACCOUNT_TYPE.actPatient) {
            let grp: userTypes.USER_GROUPS = this.loginSvc.getHighestGroup(userInfo, this.appSvc.getCurrentAccount());
            if (grp >= userTypes.USER_GROUPS.upAD) {
              this.privateNetworkAccess = true;
            }
            this.messageService.logMessage(IceTypes.LOGTYPE.ltError, "Patient Access Status: Action needed; There is no patient portal setup to contact the patient.  Go to Patient Portal setup and try again.");
          }
          else {
            let feaAccess: userTypes.USER_FEATURE_ACCESS = userTypes.USER_FEATURE_ACCESS.ufaNone;
            feaAccess = this.loginSvc.getFeatureAccess(userInfo, this.appSvc.getCurrentAccount(), userTypes.USER_FEATURES.ufPHR);
            if (feaAccess == userTypes.USER_FEATURE_ACCESS.ufaFullControl) {
              this.privateNetworkAccess = true;
            }
          }
        }
      },
      error => {
        if (this.appSvc.getCurrentAccountType() == IceTypes.ACCOUNT_TYPE.actPatient) {
          this.messageService.logMessage(IceTypes.LOGTYPE.ltError, "Patient Access Status: Action needed; There is no patient portal setup to contact the patient.  Go to Patient Portal setup and try again.");
        }
        console.log(JSON.stringify(this.domainSvc.getLastErrors()));
      });

    if (IceTypes.ACCOUNT_TYPE.actPatient == accountType) {
      this.domainSvc.getPatientProviderMembersList(account).subscribe(
        data => {
          if (data && data.length > 0) {
            this.members = this.members.concat(data);

            let opts = data.map(m => { return { value: m.login_user_name, name: m.getdisplayname() + " (member from '" + m.nameofnetwork + "' network)" } });
            this.recipientsCtrl.setOptions(this.recipientsCtrl.getOptions().concat(opts));
          }
        },
        error => {
          this.messageService.logMessage(IceTypes.LOGTYPE.ltError, "There are no patient providers associated with this patient.");

          console.log(JSON.stringify(this.domainSvc.getLastErrors()));
        });
    }
  }

  private setMemberAutomcompleteList(msg: message): void {
    if (msg && msg.trans_account.length > 0) {
      this.domainSvc.getMembersList(msg.trans_account, msg.account_type).subscribe(
        data => {
          if (data && data.length > 0) {
            this.setRecipientOptions(data);
          }
        },
        error => {
          console.log(JSON.stringify(this.domainSvc.getLastErrors()));
        });
    }
  }

  private setRecipientOptions(data) {
    this.members = this.members.concat(data);
    let opts = data.map(m => { return { value: m.login_user_name, name: m.getdisplayname() } });
    this.recipientsCtrl.setOptions(this.recipientsCtrl.getOptions().concat(opts));
  }
}
